export const CustomerProjectDetailPublish = () => {
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">프로젝트 상세보기</h3>
                    <div className="filter_toolbar">
                        <label className="form-label m-0 w-120px">상태</label>
                        <select className="form-select h-34px w-150px">
                            <option>진행</option>
                        </select>
                        <button className="btn btn-info w-80px h-34px">저장</button>
                    </div>
                </div>
                <h5 className="subheading mt-0">프로젝트 기본정보</h5>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th>프로젝트 명</th>
                                <td colSpan={3}>Xx대학교 xx교체</td>
                            </tr>
                            <tr>
                                <th style={{ width: "16.66%" }}>생성일자</th>
                                <td style={{ width: "33.34%" }}>2024-05-05</td>
                                <th style={{ width: "16.66%" }}>생성자</th>
                                <td>SYSTEM</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="content_wrap">
                <h5 className="subheading mt-0">프로젝트 정보</h5>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th style={{ width: "16.66%" }}>프로젝트 명</th>
                                <td style={{ width: "33.34%" }}>이소희</td>
                                <th style={{ width: "16.66%" }}>고객사</th>
                                <td>(주) 구구구</td>
                            </tr>
                            <tr>
                                <th>PM</th>
                                <td>MDSTECH</td>
                                <th>매출처</th>
                                <td>(주)지지지</td>
                            </tr>
                            <tr>
                                <th>투입 인원</th>
                                <td>1명</td>
                                <th>요청자</th>
                                <td>홍길동 대리</td>
                            </tr>
                            <tr>
                                <th>가능성</th>
                                <td></td>
                                <th>시작일</th>
                                <td>2024-12-02</td>
                            </tr>
                            <tr>
                                <th>프로젝트 설명</th>
                                <td>프로젝트 설명 내용</td>
                                <th>종료일</th>
                                <td>2024-12-31</td>
                            </tr>
                            <tr>
                                <th>비고</th>
                                <td colSpan={3}></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

        </>
    );
}